/*
 * Project: xpenser-client
 * FilePath: /src/app/pages/404-error/index.tsx
 * File: index.tsx
 * Created Date: Friday, September 18th 2020, 6:27:09 pm
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Fri Sep 18 2020
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2020 Pixel Ventures Ltd.
 * ------------------------------------
 * <<licensetext>>
 */

import React from 'react'
import { useHistory } from 'react-router-dom'

export default function Page404Error () {
  const history = useHistory()
  return (
    <>
      <p>404 - Page Not Found</p>
      <button onClick={history.goBack}>Back</button>
    </>
  )
}
